import { always, curry, equals, findIndex, identity, ifElse, compose } from 'ramda';

/** 可提供 defaultIndex 的 findIndex() */
export const findIndexDefault = curry((fn, defaultIndex, data) =>
  compose(ifElse(equals(-1), always(defaultIndex), identity), findIndex(fn))(data)
);
